/* SW49 — blog yazısı: başlıklardan içindekiler tablosu */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var toc = document.querySelector('[data-sw-toc]');
    var content = document.querySelector('[data-sw-article-content]');
    if (!toc || !content) return;
    var heads = content.querySelectorAll('h2');
    if (heads.length < 3) return;
    var list = toc.querySelector('[data-sw-toc-list]');
    heads.forEach(function (h, i) {
      if (!h.id) {
        h.id = 'sw-h-' + (i + 1) + '-' + h.textContent.trim().toLowerCase()
          .replace(/[^a-z0-9ğüşöçıâ\s-]/gi, '').replace(/\s+/g, '-').slice(0, 40);
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
    if (window.matchMedia('(min-width: 750px)').matches) toc.open = true;
  });
})();
